<div v-if="isSet() && defaultSortOrder">
  <section class="mt-section">
    <v-grid in="10" class="mt-group">
      <v-row>
        <v-col has="10">
          <p v-html="graphicsDescription"></p>
        </v-col>
      </v-row>
    </v-grid>

    <div v-if="scanStatus === false">
      <span :class="$style.malwareIcon"></span>
      <span :class="$style.malwareText"> {{$t('malwareScan.malwareDetectionMessage')}} </span>
    </div>

    <div v-if="defaultSortOrder.graphics.length > 0">
      <div v-if="scanStatus === ''">
        <span :class="$style.searchingMalware"></span>
        <span :class="$style.malwareText"> {{$t('malwareScan.scanInitiationMessage')}} </span>
      </div>
      <div v-if="scanStatus === true">
        <span :class="$style.successMalwareIcon"></span>
        <span :class="$style.malwareText"> {{$t('malwareScan.scanCompletionMessage')}} </span>
      </div>
    </div>
  
    <fou-group>
      <graphic-uploader :id="$vId(this, `graphic-uploader`)" :sort-order="defaultSortOrder" />
    </fou-group>
  </section>

  <section :class="$style.image_info_container">
    <fou-group>
      <p :class="$style.image_info">{{$t('pages.submissions.index.additional_detail_imageuploader', {
                        minWidth: minImageWidth,
                        minHeight: minImageHeight,
                    })}}</p>
    </fou-group>
    <fou-group>
      <div :class="$style.posters">
        <v-grid in="10">
          <v-row>
            <v-col has="8" off="1">
              <fou-expand class="out-left out-right" :id="$vId(this)"
                :trigger-title="$t('pages.submissions.components.graphics.poster.expand.more')"
                :trigger-title-open="$t('pages.submissions.components.graphics.poster.expand.less')" :options="{
                  minHeight: 100,
                  gradient: false,
                  triggerPos: 'end'
                }" :style="this.displayStyle">
                <draggable element="ul" class="mt-list" :class="$style.posterBox"
                  :id="$vId(this, `graphics-${defaultSortOrder.iso}`)" :list="imagesWithPlaceHolder" :options="{
                    'onUpdate': updatePoster(defaultSortOrder.iso),
                    'handle': '.js-handle',
                    'filter': '.js-ignore'
                  }" @start="draggableStart" @end="()=> {updatePoster(defaultSortOrder.iso), draggableEnd}">
                  <template #item="{element, index}">
                    <div class="mt-list-item js-handle" :class="$style.posterItem" :key="index">
                      <li>
                        <span v-if="element.graphicId">
                          <graphic-item :id="$vId(this, `graphic-${index}`)" :item="element" :index="index + 1"
                            v-tooltip="{content: element?.image?.fileName, placement: 'bottom'}" />
                        </span>
                        <span v-else>
                          <div :class="$style.item"></div>
                        </span>
                      </li>
                    </div>
                  </template>
                </draggable>
              </fou-expand>
            </v-col>
          </v-row>
        </v-grid>
      </div>
    </fou-group>
    <fou-group>
      <p :class="$style.additional_image_info">
        {{ $tc('pages.submissions.components.graphics.poster.uploaded_items', defaultSortOrder.graphics.length, {count:
        defaultSortOrder.graphics.length})}}
      </p>
    </fou-group>
    <fou-group>
        <p :class="$style.image_info">{{$t('pages.submissions.components.graphics.poster.description')}}</p>
    </fou-group>
    <fou-group>
      <TextField :name="`posters_${defaultSortOrder.iso} graphics`" :id="$vId(this, 'city')" type="hidden"
        :label="`Poster (${defaultSortOrder.iso})`" v-model="defaultSortOrder.graphics.length"
        :placeholder="$t('pages.submissions.components.graphics.poster.validation_as')"
        :input-class="[$style.inputFont, $style.inputWidth1, {'mt-input--error': Object.hasOwn(formError, `posters_${defaultSortOrder.iso} graphics`)}]"
        :error-class="[$style.errorField]"
        :rules="submission.isLive ? `fou_slides:0,15` : `fou_slides:5,15`" />
    </fou-group>
  </section>
</div>